import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import Initialiser from 'initialiser';
import { default as fetching } from 'ducks/modules/fetching';
import { default as user } from 'ducks/modules/user';
import { default as dashboard } from 'ducks/modules/dashboard';
import { default as works } from 'ducks/modules/works';
import { default as work } from 'ducks/modules/work';
import { default as hover } from 'ducks/modules/hover';
import { default as toaster } from 'ducks/modules/toaster';
import { default as upload } from 'ducks/modules/upload';
import { default as calendly } from 'ducks/modules/calendly';
import { default as notifications } from 'ducks/modules/notifications';
import { default as performance } from 'ducks/modules/performance';
import { default as messages } from 'ducks/modules/messages';
import { default as royalties } from 'ducks/modules/royalties';
import { default as file_status } from 'ducks/modules/file_status';
import { default as matching_dashboard } from 'ducks/modules/matching_dashboard';
import { default as api_tokens } from 'ducks/modules/api_tokens';

const loggerMiddleware = createLogger();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    combineReducers({
        fetching,
        user,
        dashboard,
        works,
        work,
        hover,
        toaster,
        upload,
        calendly,
        notifications,
        performance,
        messages,
        royalties,
        file_status,
        matching_dashboard,
        api_tokens,
    }),
    Initialiser.initialState,
    composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware)),
);

export default store;
